import React from 'react';

interface NavItemProps {
  title: string;
  icon?: string;
  active?: boolean;
}

const NavItem: React.FC<NavItemProps> = ({ title, icon, active = false }) => {
  return (
    <div className={`nav-item ${!icon ? 'no-icon-item' : ''} ${active ? 'active' : ''}`}>
      {icon && (
        <img
          className="home-nav-link"
          alt="Home"
          src={icon}
        >
        </img>
      )}
      <span>{title}</span>
    </div>
  );
}

export default NavItem;
